export default "__VITE_ASSET__BYJ8jhX6__"